<template>
  <div id="admin-tester-stats">
    <div class="container">
      <div class="row m-2">
        <div class="col-12">
          <button
            :class="{
              btn: true,
              'float-right': true,
              'm-2': true,
              'btn-outline-secondary': !states.showAllUsers,
              'btn-primary': states.showAllUsers
            }"
            @click="localEventHandler('click-show-all-users')"
          >
            Show hidden users
          </button>
        </div>
      </div>

      <table class="table">
        <thead class="thead-dark">
          <tr>
            <th>Tester</th>
            <th>
              <small><b> # Correct Ans/Total</b></small>
            </th>
            <th>
              <small>
                <b>
                  Time for a detail check <br />
                  in minute (Q1 | Q2 | Q3)
                </b>
              </small>
            </th>
            <th>
              <small>
                <b>
                  Time for a simple check <br />
                  in minute (Q1 | Q2 | Q3)
                </b>
              </small>
            </th>
            <th>
              <small>
                <b>
                  # Reports <br />
                  <span>
                    (<i class="fa fa-check" /> / <i class="fa fa-times" /> /
                    Total)
                  </span>
                </b>
              </small>
            </th>
          </tr>
        </thead>
        <tbody v-if="!states.loadingTesters && !states.loadingUserStats">
          <template v-for="t in testers">
            <tr
              v-if="states.showAllUsers || hiddenUserIds.indexOf(t.id) == -1"
              :key="t.id"
            >
              <td>
                <i
                  v-if="hiddenUserIds.indexOf(t.id) != -1"
                  class="fa fa-eye-slash mx-1"
                />
                <span>{{ t.name }} ({{ t.id }})</span>
              </td>
              <template v-for="us in userStats.filter(x => x.userId == t.id)">
                <td :key="`${us.userId}-${us.batchId}-1`">
                  {{
                    us.numAnsCorrect
                      ? `${us.numAnsCorrect}/${us.numAnsCorrect +
                          us.numAnsWrong} (${(
                          (us.numAnsCorrect /
                            (us.numAnsCorrect + us.numAnsWrong)) *
                          100
                        ).toFixed(2)}%)`
                      : '-'
                  }}
                </td>
                <td :key="`${us.userId}-${us.batchId}-2`">
                  {{
                    us.timeDetailCheckQuartiles
                      ? us.timeDetailCheckQuartiles
                          .map(x => (x / 60).toFixed(2))
                          .join(' | ')
                      : '-'
                  }}
                </td>
                <td :key="`${us.userId}-${us.batchId}-3`">
                  {{
                    us.timeSimpleCheckQuartiles
                      ? us.timeSimpleCheckQuartiles
                          .map(x => (x / 60).toFixed(2))
                          .join(' | ')
                      : '-'
                  }}
                </td>
                <td :key="`${us.userId}-${us.batchId}-4`">
                  {{
                    us.numReportByVerified.some(x => x != 0)
                      ? `${us.numReportByVerified[0]} / ${
                          us.numReportByVerified[1]
                        } / ${us.numReportByVerified.reduce(
                          (a, b) => a + b,
                          0
                        )}`
                      : '-'
                  }}
                </td>
              </template>
              <template
                v-if="userStats.filter(x => x.userId == t.id).length == 0"
              >
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
              </template>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import api_admin_userstats from '@/api/api_admin_userstats'
export default {
  name: 'AdminUserStats',
  data () {
    return {
      states: {
        batchId: null,
        showAllUsers: false,
        loadingTesters: false,
        loadingUserStats: false
      },
      hiddenUserIds: [],
      testers: [],
      userStats: []
    }
  },
  created () {
    this.states.batchId = sessionStorage.batchId
    this.hiddenUserIds = localStorage.hiddenUserIds
      ? JSON.parse(localStorage.hiddenUserIds)
      : []
    this.fetchTesters()
    this.fetchUserStats()
  },
  methods: {
    fetchTesters () {
      this.states.loadingTesters = true
      api_admin_userstats.get_testers().then(testers => {
        this.testers = testers
        this.testers.sort((a, b) => a.name.localeCompare(b.name))
        this.states.loadingTesters = false
      })
    },
    fetchUserStats () {
      this.states.loadingUserStats = true
      api_admin_userstats
        .get_user_stats(this.states.batchId)
        .then(userStats => {
          this.userStats = userStats
          this.states.loadingUserStats = false
        })
    },
    localEventHandler (name, event) {
      if (name == 'click-show-all-users') {
        this.states.showAllUsers = !this.states.showAllUsers
        this.$forceUpdate()
      }
    }
  }
}
</script>
